'use client'

import CategoriesSlider from '@/components/CategoriesSlider'
import Footer from '@/components/Footer/Footer'
import Header from '@/components/header/Header'
import NewsMaterialsTitle from '@/components/NewsMaterialsTitle'
import React, { useEffect, useState } from 'react'
import { categoriesSliderList, usefulMatCardList } from '@/assets/data/useful-materials'
import Filter from '@/components/filter/Filter'
import { filterTagsNews, selectList } from '@/assets/data/filter'
import FilterTags from '@/components/filter/FilterTags'
import UsefulMatCard from '@/components/useful-materials/UsefulMatCard'
import { useFilterMaterialsMutation, useGetAllMaterialsQuery, useGetMaterialsCategoriesQuery } from '@/redux/services/materialsApi'
import { useGetMaterialsFilterTagsQuery } from '@/redux/services/tagsApi'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '@/redux/store'
import { usePathname, useRouter, useSearchParams } from 'next/navigation'
import { setMaterialsFilterTags, setMaterialsSearch, setMaterialsSelected, setResetCatalogFilters } from '@/redux/features/filterSlice'

interface FilteredData {
    count: number,
    items: any[]
}

const UsefulMaterialsModule = () => {
    const router = useRouter()
    const dispatch = useDispatch()
    const pathname = usePathname()
    const params = useSearchParams()
    const [tags, setTags] = useState([])
    const [page, setPage] = useState(0)
    const [count, setCount] = useState(10)
    const [filteredData, setFilteredData] = useState<FilteredData>()
    const [isFilterFilled, setIsFilterFilled] = useState(false)
    const { materialsFilterTags, materialsSearch, materialsSelected } = useSelector((state: RootState) => state.filter)
    const [submitForm, filterResult] = useFilterMaterialsMutation()
    const { data: tagsData } = useGetMaterialsFilterTagsQuery()
    const { data: materialsCategoriesData } = useGetMaterialsCategoriesQuery()


    useEffect(() => {
        dispatch(setResetCatalogFilters())
    }, [])

    const filterBody = {
        get: count,
        page: 0,
        ...(materialsFilterTags && materialsFilterTags.length && { tags: materialsFilterTags }),
        ...(materialsSelected && materialsSelected.length && { category: materialsSelected }),
        ...(materialsSearch && { title: materialsSearch })
    }

    useEffect(() => {
        setTags(tagsData)
    }, [tagsData])

    useEffect(() => {
        submitForm(filterBody).then((filterData: any) => {

            if (filterBody.tags || filterBody.title || filterBody.category) {
                setIsFilterFilled(true)
            } else {
                setIsFilterFilled(false)
            }

            setFilteredData(filterData.data)
        })
    }, [materialsSearch, materialsFilterTags, materialsSelected, count])

    useEffect(() => {
        const params = `${materialsFilterTags.length ? `&tags=` + materialsFilterTags.join(',') : ''}`
            + `${materialsSelected.length ? `&category=` + materialsSelected.join(',') : ''}`
            + `${materialsSearch ? `&title=` + materialsSearch : ''}`

        router.push(`${pathname}?${params.slice(1)}`, { scroll: false })

    }, [materialsFilterTags, materialsSearch, materialsSelected])

    useEffect(() => {
        const getParams = () => {
            if (params.has('title')) {
                dispatch(setMaterialsSearch(params.get('title')))
            }
            if (params.has('tags')) {
                dispatch(setMaterialsFilterTags([...params.get('tags').split(',')?.map(Number)]))
            }
            if (params.has('category')) {
                dispatch(setMaterialsSelected([...params.get('category').split(',')?.map(Number)]))
            }
        }
        getParams()
    }, [params])

    return (
        <main style={{ background: '#f3f6fe' }}>
            <Header 
                isWhiteLogo={true}
            />
            <div className='useful-materials container'>
                <NewsMaterialsTitle />
                {materialsCategoriesData && <CategoriesSlider
                    page={`useful-materials`}
                    list={materialsCategoriesData}
                />}
                {filteredData && <div className='useful-materials__content'>
                    <div className='useful-materials__card-side'>
                        <Filter selectList={selectList} />
                        {tags && <FilterTags list={tags} />}
                        <ul className='useful-materials__card-list'>
                            {filteredData?.items?.length ? filteredData.items?.map(card => (
                                <UsefulMatCard key={card.id} item={card} />
                            ))
                                :
                                <h2 style={{ margin: '200px 0' }} className='catalog__nothing-found'>Статей по Вашему запросу не найдено</h2>
                            }
                        </ul>
                        {filteredData.count !== count && count < filteredData.count &&
                            <button
                                onClick={() => setCount(count + 10)}
                                className='useful-materials__button button-more'>
                                Загрузить еще
                            </button>
                        }
                    </div>
                    <div className='useful-materials__sort-side'>
                        {tags && <FilterTags list={tags} />}
                    </div>
                </div>}
            </div>
            <Footer mapTheme='light'/>
        </main>
    )
}

export default UsefulMaterialsModule
